import { createFileRoute } from '@tanstack/react-router';

import { MembersPage } from '../../pages/settings';

export const Route = createFileRoute('/_shell/settings/members')({
  component: MembersPage,
});
